import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { filterValue } from 'src/app/core/helpers/helperfunc';
import { AgentsService } from 'src/app/core/services/agents/agents.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { UsersService } from 'src/app/core/services/users/users.service';
import { AgentComponent } from '../agent.component';

@Component({
  selector: 'app-add-tag-popup',
  templateUrl: './add-tag-popup.component.html',
  styleUrls: ['./add-tag-popup.component.scss']
})
export class AddTagPopupComponent  implements OnInit, OnDestroy {
  agentRm: any;
  id: any;
  commentInput: string = '';
  action: any;
  userDetails: any;
  form: FormGroup;
  status: string = '';

  rm_list: any;
  rm_name: any[] = [];
  public filtered_rm: ReplaySubject<any> = new ReplaySubject<any>(1);
  public rm_filter_control: FormControl<string> = new FormControl<string>('');

  rm_pagination = {
    skip: 0,
    limit: 100
  }
  total_rm_count: number = 0;
  rm_offset: number = 0;

  filterValue = filterValue;
  private _unsubscribeAll: Subject<any> = new Subject();

  constructor(
    public dialogRef: MatDialogRef<AddTagPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _agentsService: AgentsService,
    private _usersService: UsersService,
    private fb: FormBuilder,
    private _toastrService: ToasterService,
    private _loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      tagName: ['', Validators.required],
    });
    
  }

  close() {
    this.dialogRef.close(false);
  }

  get f() {
    return this.form.controls;
  }

  addTag(){
    this._agentsService.updateTag(this.data?.fileId, this.form?.value.tagName)
    .pipe(takeUntil(this._unsubscribeAll))
    .subscribe(result => {
      // this.getEditAgentDetails();
      this._loaderService.hideLoader();
      this.close()
    }, (err) => {
      this.close()
      this._loaderService.hideLoader();
    })
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }


}
